'use client';

import { IS_RUNNING_SERVER_SIDE } from '@/config/app.config';
import { GHOST_ACCOUNT_QUERY_PARAM } from '@/constants/navigation';
import { LOCAL_STORAGE_KEYS } from '@/constants/storage';

declare const window: any;

export const getIsGhostAccount = (): boolean => {
  if (IS_RUNNING_SERVER_SIDE) {
    return false;
  }

  return (
    location?.href?.includes(`${GHOST_ACCOUNT_QUERY_PARAM}=true`) ||
    localStorage?.getItem?.(LOCAL_STORAGE_KEYS.ghostsAccount) === 'true'
  );
};

export const getIsProdEnvironment = (): boolean => {
  return process.env.NEXT_PUBLIC_NODE_ENV === 'production';
};

export const getIsRunningServerSide = (): boolean => {
  return typeof window === 'undefined';
};

export const getMobileOperatingSystem = (): string | null => {
  if (IS_RUNNING_SERVER_SIDE) {
    return null;
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
    return 'ipad';
  }

  return null;
};

export const getIsMobile = (): boolean => {
  return getMobileOperatingSystem() !== null;
};
